// frontend/src/utils/geocodingApi.js
import axios from '../axiosConfig';
import logger from './logger';

const baseUrl = import.meta.env.VITE_API_URL; // Adjust this to match your backend URL

const requireEntityId = (entityId) => {
  if (!entityId) {
    throw new Error('entityId is required for geocoding requests');
  }
  return entityId;
};

export const geocodeAddress = async (entityId, address) => {
  const scopedEntityId = requireEntityId(entityId);
  try {
    const response = await axios.post(`${baseUrl}/api/geocode/${scopedEntityId}`, { address });
    return response.data;
  } catch (error) {
    logger.error('Geocoding API error', error);
    throw error;
  }
};

export const reverseGeocode = async (entityId, lat, lng) => {
  const scopedEntityId = requireEntityId(entityId);
  try {
    const response = await axios.post(`${baseUrl}/api/reverse-geocode/${scopedEntityId}`, { lat, lng });
    return response.data;
  } catch (error) {
    logger.error('Reverse geocoding API error', error);
    throw error;
  }
};
